import { GuestRecipeBoxData } from '../../../recipes/providers/guest-recipe-box-data';
import { RecipeBoxDataGateway } from '../../../recipes/providers/recipe-box-data-gateway';
import { Injectable } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { PageRef } from '../../../../core/core.module';
import { AlertController } from 'ionic-angular';
//import { AppSettings } from '../../../../config/app-settings';
import { RecipeData } from '../../../recipes/providers/recipe-data';
import { StoreLocatorData } from '../../../store-locator/providers/store-locator-data';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoginCommon {
	recipeBoxData: any;
	constructor(
		public userData: UserData,
		public pageRef: PageRef,
		//public settings: AppSettings,
		public recipeData: RecipeData,
		public recipeBoxGateway: RecipeBoxDataGateway,
		public guestRecipeBoxData: GuestRecipeBoxData,
		public storeLocatorData : StoreLocatorData,
		public alertCtrl: AlertController

	) {

	}

	public commonMethod() {
		console.log("Hello Login");
	}

	public fbLogin() {
		this.userData.facebookLogin();
	}

	public googleLogin() {
		this.userData.googleLogin();
	}

	public onLogin(form, nav, login) {
		let self = this;
		if (form.valid) {
			self.userData.login(login.email, login.password).subscribe((res) => {
				if (!res.success) {
					return;
				}
				var userId = res.user.uid;
				this.recipeBoxData = this.recipeBoxGateway.getService(userId);
				//Merge user recipe for current user
				this.guestRecipeBoxData.getUserRecipes('guest').subscribe(localUserRecipes => {
					console.log(localUserRecipes);
					this.recipeBoxData.syncLocalToRemote(userId,localUserRecipes);
					
				});

				this.handleCurrentStore(res.user).subscribe(result => {
					console.log("Redirecting to Account");
					nav.setRoot(this.pageRef.get('home'));
				});
			});
		}
	}

	private handleCurrentStore(user){
		return Observable.create((observer) =>{
			this.storeLocatorData.getCurrentStore().subscribe(store => {
				var userStoreId = user.StoreID || '-KakusFuVW4VKjFEwOLk';
				var currentStoreId = store !== null ? store.$id || store.$key : '';
				if((store && currentStoreId ==  userStoreId) || !store){
					if(!store){
						this.storeLocatorData.setCurrentStore({$key: userStoreId});
					}
				}else{
					let alert = this.alertCtrl.create({
						title: '',
						subTitle: 'Your current selected store is different from your preferred store, please indicate which ad you want to view?',
						buttons: [{
							text: 'Preferred Store',
							handler: data=>{
								this.storeLocatorData.setCurrentStore({$key: userStoreId});
								observer.next(true);
							}
						},
						{
							text: 'Selected Store',
							handler: data=>{
								observer.next(true);
							}
						}]

					});

					alert.present();
				}
			});
		    observer.next(true);
		});
		
	}
}



// WEBPACK FOOTER //
// ./src/modules/account/pages/login/login.common.ts